const videoTriggers = document.querySelectorAll('.video-trigger');
const videoModal = document.getElementById('videoModal');
const videoPlayer = document.getElementById('videoPlayer');

if (videoModal && videoTriggers) {
    videoTriggers.forEach((trigger)=> {
        trigger.addEventListener('click', (e)=> {
            e.preventDefault();
            let movieID = e.target.href;
            console.log(movieID);
            let movieEmbed = '';

            if (movieID.match(/youtu\.be/i)) {
                movieID = movieID.split('/');
                movieID = movieID[3];
                movieEmbed = `<div class="responsive-embed"><iframe id="player" src="https://www.youtube.com/embed/${movieID}?showinfo=0&autoplay=1" width="1280" height="720" frameborder="no" allowfullscreen></iframe></div>`;
            } else if (movieID.match(/youtube.com/i)) {
                movieID = movieID.split('=');
                movieID = movieID[1];
                movieEmbed = `<div class="responsive-embed"><iframe id="player" src="https://www.youtube.com/embed/${movieID}?showinfo=0&autoplay=1" width="1280" height="720" frameborder="no" allowfullscreen></iframe></div>`;
            } else if (movieID.match(/vimeo\.com/i)) {
                movieID = movieID.split('/');
                movieID = movieID[3];
                movieEmbed = `<div class="responsive-embed"><iframe src="https://player.vimeo.com/video/${movieID}?autoplay=1" width="100%" height="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>`;
            } else {
                movieEmbed = '<p>Error loading video - please check URL</p>';
            }
            videoPlayer.innerHTML = movieEmbed;

        });
    })

  videoModal.addEventListener('hidden.bs.modal', ()=>{
      videoPlayer.innerHTML = '';
  });
}

